<template>
  <div>
    <div style="margin-top: 50px;">
      <div id="feature_list_port" style="width: 100%; max-width: 1920px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
          <div style="display: flex; flex-direction: column; align-items: center;">
              <span :style="'font-size: 34px; font-weight: 500;'">
                Features
              </span>
          </div>
          <div :style="'margin-top: 50px; width: 100%; display: flex; flex-direction: '+($store.getters.getScreenWidth<580 ? 'column' : 'row')+'; flex-wrap: wrap; justify-content: space-between; align-items: '+($store.getters.getScreenWidth<1024 ? 'center' : 'space-between')+';'">
              <div 
                v-for="(data, index) in getFeatureList"
                :key="index"
                :style="'width: '+(getFeatureBoxWidth)+'px; min-height: 200px; max-height: 200px; margin: 20px; padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; text-align: left; border: 1px solid #383838; border-radius: 25px;'">
                    <img :src="getbaseURL+''+data.icon" style="width: 20px; margin-top: 20px;" alt="">
                    <span style="font-size: 16px; font-weight: 500; margin-top: 20px;" v-html="data.label">
                    </span>
                    <div :style="'font-size: 14px; margin-top: 10px; max-width: '+(getFeatureBoxWidth)+'px;'">
                        <span v-html="data.content">

                        </span>
                    </div>
              </div>

          </div>
          <div style="margin-top: 100px; width: 100%; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;">
              <img :src="getbaseURL+'Updates.svg'" style="width: 50px;" alt="">
              <span :style="'font-size: 22px; font-weight: 500; margin-top: 50px;'">
                As part of our commitment towards better service and user experience,<br>we continuously update the Easy Tailor App<br>by adding new features with time, at no extra cost.
              </span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        getbaseURL() {
          return 'https://etacdn.b-cdn.net/new-website/feature-icons/'
        },
        getFeatureBoxWidth() {
            
            let width = this.$store.getters.getScreenWidth
            let returnWidth = 0

            if(width < 1030 && width >= 1011) {
                returnWidth = width/4.05
            } else if(width < 1011 && width >= 917) {
                returnWidth = width/4.2
            } else if(width < 917 && width >= 824) {
                returnWidth = width/4.4
            } else if(width < 824 && width >= 786) {
                returnWidth = width/4.5
            } else if(width < 786 && width >= 754) {
                returnWidth = width/4.6
            } else if(width < 754 && width >= 699) {
                returnWidth = width/4.8
            } else if(width < 699 && width >= 695) {
                returnWidth = width/2.7
            } else if(width < 695 && width >= 630) {
                returnWidth = width/2.8
            } else if(width < 630 && width >= 580) {
                returnWidth = width/2.9
            } else if(width < 580) {
                returnWidth = width/1.5
            } else {
                returnWidth =width/4.2
            }

            return Math.round(returnWidth)

        },
        getFeatureBoxHeight() {
            if(this.$store.getters.getScreenWidth < 1030 && this.$store.getters.getScreenWidth >= 950) {
                //return (this.getFeatureBoxWidth/1.5)
            }
            return Math.round(this.getFeatureBoxWidth/2.1)
        },
        getFeatureList() {
            return [
                {label: 'Customization', icon: 'settings.svg', content: 'Admin can customize the app to meet the business requirements.'},
                {label: 'Multiple Store', icon: 'store-solid.svg', content: 'Easy tailor app makes it really easy to manage multiple stores in an uncomplicated way.'},
                {label: 'Integrated e-Payment', icon: 'payment.svg', content: 'You can generate invoices and receive payment directly with our integrated e-payment system.'},
                {label: 'Client History', icon: 'client-history.svg', content: "Keep history of client's measurement, style choices, style options, standard sizes, and more."},
                {label: 'Inventory Management', icon: 'inventory.svg', content: 'Update and review stocks, manage inventory, vendor and purchase details.'},
                {label: 'Integrated Bio-Metric', icon: 'Bio-metric.svg', content: 'Employee attendance can be recorded by using the integrated bio-metric machine.'},
                {label: 'Intra-Branch Transfer', icon: 'intra-branch.svg', content: 'Transfer fabrics, ready items or any inventory item from warehouse to stores or vice-versa and generate transfer reciepts.'},
                {label: 'Sales Planner Calendar', icon: 'calendar-days-solid.svg', content: 'Monitor which orders have passed the deadline or are due for deliveries you can also change the priority dates for specific orders.'},
                {label: 'Production Planner Calendar', icon: 'calendar-days-solid.svg', content: 'Supervise and manage all the workings of production department from one single point.'},
                {label: 'Access to Worker', icon: 'worker-availability.svg', content: 'Workers can view work-order in their mobile phones. They can view the assigned work or can assign work to themselves as well.'},
                {label: 'Automated Delivery Date Forecast', icon: 'delivery-date.svg', content: 'Forecast delivery date based on the production load automatically.'},
                {label: 'Automate Worker Availability', icon: 'users.svg', content: "Estimate the availability of worker based on worker's work load."},
                {label: 'Automated Ready-Garment Transfer', icon: 'work-order-transfer.svg', content: 'Automated transfer of ready garments from factory to store and vice-versa.'},
                {label: 'Employee Payroll', icon: 'payroll.svg', content: 'Generate employee payroll, manage employee loan, etc, with our automated system.'},
                {label: 'Worker Piece Rate Automation', icon: 'piece-rate.svg', content: 'Automated worker piece rate based payroll calculation.'},
                {label: 'Monitor Expenses', icon: 'expenses.svg', content: 'Manage and monitor day-to-day expenses. Also view all the transaction details.'},
                {label: 'Integrated Communication', icon: 'whatsapp.svg', content: 'Send messages directly to clients with our integrated WhatsApp, Email, and SMS system.'},
                {label: 'HR Management', icon: 'HR.svg', content: 'Automated overtime calculation based on holidays, employee timings and weekdays.'},
                {label: 'Automate Data Backup', icon: 'data-backup.svg', content: 'Our system takes backup automatically every hour, every 12 hours, and weekly, to keep your data safe in case of unforeseen circumstances.'},
                {label: 'Manual Data Back-Up and Export', icon: 'manual-data-backup.svg', content: 'You can take manual backups and export data in excel sheet so you can always have it with you.'},
                {label: 'Tally Export', icon: 'Tally.svg', content: 'Export data for Tally with one-click.'}
            ]
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Features/Row2.vue